import { KioskSetting } from "../models/kiosk";

export class KioskTicketTemplateCssValueConverter {

    toView(setting: KioskSetting, data: any) {
        var css = data.css;
        if (setting !== undefined && !setting !== null && setting.value !== undefined && setting.value !== null && setting.value.length > 0) {
            css = `${data.css} ${data.extraCss}`;
        }
        return css;
    }
}